export enum Panel {
  ManageAccounts = 'ManageAccounts',
  SelectAccounts = 'SelectAccounts',
  ConnectProvider = 'ConnectProvider',
}
